<div
  class="ice-badge"
  [ngClass]="type + '-badge'"
  [ngStyle]="{ 'border-radius': borderRadius, 'font-size': fontSize, padding }"
>
  @if (icon) {
    <mat-icon class="badge-icon" [svgIcon]="icon" />
  }
  <ng-content />
</div>
